import { Map } from 'immutable';
import { POPULATE_CAMPAIGN_USERS } from '@constants/actions';
import { CAMPAIGN_USER_STATUS } from '@localisation/components';

const aggregationInitial = Object.values(CAMPAIGN_USER_STATUS).reduce((countObject, userStatus) => {
  const newCountObject = { ...countObject };
  newCountObject[userStatus.status] = 0;
  return countObject;
}, {});

const initialState = Map({
  campaignUserList: [],
  totalCount: 0,
  userAggregation: aggregationInitial
});

const CampaignUser = (state = initialState, action) => {
  const actionPayload = action.payload;
  switch (action.type) {
    case POPULATE_CAMPAIGN_USERS:
      const newAggregation = actionPayload.aggregation;
      const newUserAggregation = { ...aggregationInitial };
      if (newAggregation) {
        newAggregation.forEach(aggregation => {
          newUserAggregation[aggregation.status] = aggregation.count;
        });
      }

      return state.set('campaignUserList', actionPayload.campaignUsers)
        .set('totalCount', actionPayload.totalCount)
        .set('userAggregation', newUserAggregation);
    default:
      return state;
  }
};

export default CampaignUser;